<template>
  <div id="editing-file-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main um-modal">
      <div class="title-area" id="modal-moving">
        <div
        class="cross_btn"
        @click="onCancel"
        >
        <span class="css-cancel"></span>
        </div>
        <h2>編集中ファイル強制解除</h2>
      </div>
      <div class="data-area">
        <table>
          <tbody>
            <tr>
              <th>管理番号</th>
              <th>製品品番</th>
              <th>編集中ユーザーID</th>
              <th>編集中ユーザー名</th>
              <th>編集開始日時</th>
              <th class="hid_th sm"></th>
            </tr>
            <tr v-if="editingList && editingList.length > 0" v-for="(file, index) in editingList" :key="index">
              <td>{{ file.fdId }}</td>
              <td>{{ file.fileCode }}</td>
              <td>{{ file.userId }}</td>
              <td>{{ file.userName }}</td>
              <td>{{ file.editingDate }}</td>
              <td class="hid_td"><button class="main_btn" @click="onDel(file)">解除</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import store from '../../store/index'
import * as App from '../../utils/App'
import LoadingModal from '../../components/common/LoadingModal'
export default {
  name: 'EditingFileModal',
  store: store,
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    prevDialog: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {
      /** モーダル判定 */
      modalShown: false
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    // ユーザー一覧
    ...mapState({
      editingList: state => state.editingList
    })
  },
  methods: {
    ...mapActions({ getAllEditingFileData: 'loadEditingList' }),
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
      this.prevDialog()
    },
    onDel: function (fileObj) {
      App.showEditingModal(fileObj)
    }
  },
  mounted: function () {
    this.$store.dispatch('loadEditingList', {reload: true})
  }
}
</script>
<style lang="scss" scoped>
.upper{
  margin-bottom: 30px;
  text-align: left;
}
.data-area {
  margin: 40px auto;
}
.title-area {
  display:flex;
}
.um-modal {
  max-height: 100%;
  max-width: 1500px;
  padding-left: 40px;
  padding-right: 40px;
}
table{
  text-align: center;
}
h2{
  margin: auto;
  padding-right: 29px;
}
.hid_th{
  background:none;
  border: none;
}
.sm {
  width: 35px;
}
.md{
  width: 127px
}
.hid_td{
  border:none;
}
/*==== 閉じるボタン ====*/
.cross_btn {
  width:19px;
  height:19px;
  padding: 3px 4px;
  /* position: absolute; */
  top:20px;
  left:30px;
  border: 1px solid #ff4500;
}
.cross_btn:hover {
  cursor: pointer;
}
.css-cancel {
  display: inline-block;
  position: relative;
  margin: 0 20px 0 7px;
  padding: 0;
  width: 3px;
  height: 20px;
  background: #000;
  transform: rotate(45deg);
  background: #ff4500;
}
.css-cancel:before {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: -8px;
  width: 20px;
  height: 3px;
  margin-top: -2px;
  background: #000;
  background: #ff4500;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/EditingFileModal.vue